screenSharePresenter.directive('screenShareCover', [
    '$interval',
    'logService',
    'contentService',
    'meetingService',
    function ($interval, logService, contentService, meetingService) {
        return {
            restrict: 'E',
            scope: {
                videoFeedCount: '&videoFeedCount',
                fullScreen: '&fullScreen',
                expanded: '&expanded'
            },
            link: function (scope, element, attrs) {
                if (meetingService.getIsSfuEnabled()) {
                    return;
                }

                var videoFeedCover = element.find('#videoFeedCover'); //Matches resolution of video feed (including black background space)
                var videoFeed = angular.element('#videoFeed');
                var coverContainer = element.find('#screenShareCoverContainer'); //Matches resolution of feed, excluding black background space
                var cover = element.find('#screenShareCover'); //Matches resolution of screenshare, excluding attendee feeds at the top

                var oldDimensions;
                var oldFeedCount = scope.videoFeedCount();
                var oldMaximizedStatus = contentService.isContentMaximized();

                //Watch for changes on window resize
                var dimensionsInterval = $interval(function () {
                    var changeDetected;

                    //Feed Count
                    var newFeedCount = scope.videoFeedCount();
                    var fullScreen = scope.fullScreen();
                    var isExpanded = scope.expanded();

                    if (oldFeedCount !== newFeedCount) {
                        oldFeedCount = newFeedCount;
                        changeDetected = true;
                    }

                    //Content Maximized
                    var newMaximizedStatus = contentService.isContentMaximized();

                    if (oldMaximizedStatus !== newMaximizedStatus) {
                        oldMaximizedStatus = newMaximizedStatus;
                        changeDetected = true;
                    }

                    //Dimensions
                    var feedCoverWidth =
                        videoFeed[0].offsetWidth > 0 ? videoFeed[0].offsetWidth : videoFeed[0].videoWidth;
                    var feedCoverHeight =
                        videoFeed[0].offsetHeight > 0 ? videoFeed[0].offsetHeight : videoFeed[0].videoHeight;

                    var newDimensions = feedCoverWidth + 'x' + feedCoverHeight;

                    if (oldDimensions !== newDimensions) {
                        oldDimensions = newDimensions;
                        changeDetected = true;
                    }

                    //Update cover resolution
                    if (changeDetected) {
                        //1280x720 is the res of the feed from fs
                        var ratio = 1280 / 720;

                        var containedWidthOfVideo;
                        var containedHeightOfVideo;

                        if (feedCoverWidth / feedCoverHeight < ratio) {
                            containedWidthOfVideo = feedCoverWidth;
                            containedHeightOfVideo = feedCoverWidth / ratio;
                        } else {
                            containedHeightOfVideo = feedCoverHeight;
                            containedWidthOfVideo = feedCoverHeight * ratio;
                        }

                        if (newFeedCount > 0) {
                            if (newFeedCount <= 6) {
                                // Less than six feeds
                                percentage = 72 / 360; // 20%
                            } else {
                                // Greater than 6 feeds
                                percentage = 44 / 360; // 11.94444444444444%
                            }

                            var topOffset = containedHeightOfVideo * percentage;

                            cover.css('top', topOffset + 'px');

                            if (newFeedCount <= 6) {
                                cover.css('bottom', '0px');
                            } else {
                                // Set bottom offset which is the same as the calculated topOffset.
                                cover.css('bottom', topOffset + 'px');
                            }
                        } else {
                            if (cover.css('top') !== '0px') {
                                cover.css('top', '0px');
                            }

                            if (cover.css('bottom') !== '0px') {
                                cover.css('bottom', '0px');
                            }
                        }

                        coverContainer.height(containedHeightOfVideo);
                        coverContainer.width(containedWidthOfVideo);

                        videoFeedCover.width(feedCoverWidth);
                        videoFeedCover.height(feedCoverHeight);
                    }
                }, 100);

                scope.$on('$destroy', function () {
                    logService.log('screenShareCover removed. Stopping dimensionsInterval...');
                    $interval.cancel(dimensionsInterval);
                });
            }
        };
    }
]);
